var CoreReportType = /* @__PURE__ */ ((CoreReportType2) => {
  CoreReportType2["Event"] = "event";
  CoreReportType2["Failure"] = "failure";
  CoreReportType2["Duration"] = "duration";
  CoreReportType2["Search"] = "search";
  CoreReportType2["Translation"] = "translation";
  return CoreReportType2;
})(CoreReportType || {});
export {
  CoreReportType
};
